import { render, staticRenderFns } from "./ChinaVis2021.md?vue&type=template&id=002653c8&"
import script from "./ChinaVis2021.md?vue&type=script&lang=js&"
export * from "./ChinaVis2021.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports